import React from 'react'

interface Props {}

const ManageOrderDetail: React.FC<Props> = () => {
  return <div>ManageOrderDetail</div>
}

export default ManageOrderDetail
